export default "__VITE_ASSET__42b94ad1__"